<template>
  <div class="flowbuilder-node-container" ref="containerEl">
    <BaseNode
      ref="nodeEl"
      :node="node"
      :icon="nodeIcon"
      @delete-node="emit('delete-node')"
      classes="bg-slate-50 dark:bg-slate-800 ring-slate-400/50 dark:ring-slate-600/50 does-terminate">
      <template #context>Exit this flow:</template>
      {{ isSystemFlow ? 'Flow execution ends here' : 'No widget is displayed' }}
    </BaseNode>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, inject } from 'vue'
import BaseNode from './BaseNode.vue'
import { getNodeIcon } from '../../utils/nodeIcons'
import type { NodeExit } from '../../types'

// Simple X icon component
const ExitIcon = {
  template: `<svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
  </svg>`
}

const props = defineProps<{
  node: NodeExit
}>()

const emit = defineEmits<{
  'node-action': [action: string, data?: any]
  'delete-node': []
}>()

const nodeEl = ref<InstanceType<typeof BaseNode> | null>(null)
const containerEl = ref<HTMLElement | null>(null)

const flow = inject('flow', ref(null)) as any
const getNodeMetrics = inject<(node: any) => any>('getNodeMetrics', () => null)

const isSystemFlow = computed(() => flow.value?.isSystemFlow === true)

// Get the appropriate icon for this node
const nodeIcon = computed(() => {
  return getNodeIcon(props.node)
})

// Get metrics for this node
const metrics = computed(() => {
  return getNodeMetrics(props.node)
})
</script>

